import { palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { View, ViewStyle } from 'react-native';

interface LineProps {
  color?: string;
  style?: ViewStyle;
  height?: number | string;
}

const Line: FC<LineProps> = (props) => {
  const { color = palette.Outline_blue } = props;

  return (
    <View
      style={[
        props.style,
        { backgroundColor: color, height: props.height || 2 },
      ]}
    />
  );
};

export default Line;
